"use strict";

import Strings from "/js/util/strings.js";

/**
 * Base class.
 * Is used by an ItemView, which are used in multi-step interactions.
 */
export default class ItemContentView {

  #$el;
  #$content;  // The main content of the ItemContentView.
  #questionObject;
  #index;
  #numItems;
  $prompt; // 'protected'

  /**  
   * Subclass should append and init its content to `$content` after `super(...)`.
   */
  constructor(questionObject, index, numItems) {

    this.#questionObject = questionObject;
    this.#index = index;
    this.#numItems = numItems;
   
    const prompt = questionObject.text
        ? `<div class="prompt">${ questionObject.text }</div>`
        : "";
    const pageIndexString = Strings.get("page_index");
    const pageIndex1 = pageIndexString.replace("%1$d", index + 1);
    const pageIndex2 = pageIndex1.replace("%2$d", numItems);
    const s = `
        <div class="item-content-view">
          <div class="ordinal">${ pageIndex2 }</div>
          <div class="item-content-view-inner">
            ${ prompt }
          </div>
        </div>
    `; 
    this.#$el = $(s);
    this.#$content = this.#$el.find(".item-content-view-inner");
    this.$prompt = this.#$content.find(".prompt");
  }

  get $el() {
    return this.#$el;
  }

  /* "Protected" */
  get $content() {
    return this.#$content;
  }

  /* "Protected" */
  get questionObject() {
    return this.#questionObject;
  }

  /* "Protected" */
  get index() {
    return this.#index;
  }

  /* "Protected" */
  get numItems() {
    return this.#numItems;
  }

  /** 
   * "Protected"
   * Callback to inform view that it has been shown.
   *
   * Subclasses may want to override to do any needed autoshrink action.
   */
  onShow() { }
}
